import {createAction, props} from '@ngrx/store';
import {Payload} from '../payload';
import {JsonRecord} from 'fp-ts/Either';

export const setClaims = createAction('[Claims] Set data', props<Payload<JsonRecord>>());
